export default {
      id: "circle__hourglass-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "img/icons.svg#circle__hourglass",
      toString: function () {
        return this.url;
      }
    }